import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { REVIEWS } from '../lib/constants';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-151">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#e6c168] text-[#e6c168]" aria-hidden="true" data-id="element-152" />)}
    </div>;
}
// Five-star reviews block.
export function ReviewsSection() {
  return <section className="px-5 py-8" data-id="element-153">
      <div className="mx-auto max-w-md" data-id="element-154">
        <h2 className="text-center font-[Montserrat] text-xl font-extrabold text-white" data-id="element-155">
          Lo que dicen quienes ya aprobaron
        </h2>

        <div className="mt-6 space-y-3" data-id="element-156">
          {REVIEWS.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="rounded-xl border border-[#c8a24a]/25 bg-white p-4 shadow-sm" data-id="element-157">
              <Stars data-id="element-158" />
              <blockquote className="mt-2 text-sm leading-relaxed text-slate-700" data-id="element-159">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-2 text-xs font-bold text-[#0b2545]" data-id="element-160">
                {r.name} ·{' '}
                <span className="font-medium text-slate-500" data-id="element-161">{r.location}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}